import React from 'react';
import { createSanitizeHtml } from 'utility';
import { Grid } from '@mui/material';
import {
    SimpleDialog,
    ButtonLoading
} from 'components';

import { makeStyles } from '@mui/styles';
import { EstelamMesage } from '../Shared/Utility';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => {
    return {
        chkItem: {
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            backgroundColor: '#f4f4f4',
            borderRadius: '8px',
            fontSize: '12px',

            border: '2px solid #f4f4f4',
            alignItems: 'center',
            padding: '2px 12px',
            margin: '4px 0',
            transitionDuration: '200ms',
            '&:hover': {
                marginLeft: '4px',
                transitionDuration: '200ms',

            }
        },
        activeItem: {
            border: '2px solid #449cc9',
        },
        colorActive: {
            color: '#2B3990',
            fontWeight: 'bold',
        },
        colorActivePlace: {
            opacity: '1'
        },
        colorPlace: {
            opacity: '0.3',
            fontWeight: 'bold'
        },
        customClassdialogContent: {
            minWidth: '440px',
            [theme.breakpoints.down('sm')]: {
                minWidth: 'auto',
            },
        }

    };
});
const MessageDg = (props) => {
    const { isOpenDg, setIsOpenDg, type, phoneNumber, title, redirectLink = '' } = props;
    const classes = useStyles();
    const navigate = useNavigate();
    return (
        <SimpleDialog
            fullWidth
            maxWidth="xs"
            customClass={classes.customClassdialogContent}
            open={isOpenDg}
            title={title}
        >
            <Grid container alignItems="center" >
                <Grid style={{ position: 'relative', width: '100%' }}>
                    <Grid style={{ textAlign: 'center' }}>

                        <div dangerouslySetInnerHTML={{ __html: createSanitizeHtml(EstelamMesage()) }}></div>
                    </Grid>
                    <Grid md={12} xs={12} lg={12}
                       style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}
                    >

                        <ButtonLoading
                            type="button"
                            variant="contained"
                            color="primary"
                            style={{ width: '100%' }}
                            name="متوجه شدم"
                            onClick={() => {
                                setIsOpenDg(false);
                                redirectLink && navigate(redirectLink)
                            }}
                        />

                    </Grid>
                </Grid>
            </Grid>


        </SimpleDialog>
    )
}

export default MessageDg;

